export type Role = 'shop' | 'lab' | 'default';

export interface IMessageButtonData {
  roleName: string;
  actionCatagory: string;
}

export const messageButtonData: Record<Role, IMessageButtonData> = {
  shop: {
    roleName: 'فروشنده',
    actionCatagory: 'callToSeller',
  },
  lab: {
    roleName: 'آزمایشگاه',
    actionCatagory: 'callToSeller',
  },
  default: {
    roleName: 'خریدار',
    actionCatagory: 'callToBuyer',
  },
};
